var experimentProviderName = Symbol('ExperimentServiceProvider');

export { experimentProviderName };
